// CSV/TSV export data generators
const CSV_GENERATORS: Record<string, (data: any) => any[]> = {
  topSearches: (data) => [
    ['Search Term', 'Count', 'Average Results'],
    ...(data.rawData || []).map((item: any) => [
      item.term, 
      String(item.count),
      String(item.avg_results || 0)
    ])
  ],
  
  agreements: (data) => [
    ['Agreement', 'Agreement Link', 'Total Clicks', 'Unique Journals'],
    ...(data.rawData || []).map((item: any) => [
      item.agreement,
      item.agreement_id ? `${window.location.origin}/agreements/${item.agreement_id}` : '',
      String(item.clicks),
      String(item.unique_journals)
    ])
  ],
  
  clicks: (data) => data?.totals ? [
    ['Column', 'Count'],
    ['Journal', String(data.totals.journal)],
    ['Payments', String(data.totals.payments)],
    ['Licenses', String(data.totals.licenses)],
    ['Publishing Models', String(data.totals.publishingModels)],
    ['Agreement description', String(data.totals.agreementDescription)],
    ...Object.entries(data.totals.quality || {}).map(([label, count]) => [label, String(count)])
  ] : [],
  
  searchFilters: (data) => data?.totals ? [
    ['Filter', 'Count'],
    ['Imprint', String(data.totals.filterImprint)],
    ['Payment', String(data.totals.filterPayment)],
    ['Licenses', String(data.totals.filterLicenses)],
    ['Publishing Models', String(data.totals.filterPublishingModel)],
    ...Object.entries(data.totals.quality || {}).map(([label, count]) => [label, String(count)])
  ] : [],
  
  accountActivity: (data) => {
    if (!data?.chart) return [];
    return [
      ['Account name', 'Searches', 'Clicks', 'Total'],
      ...data.chart.labels.map((account: string, i: number) => [
        account,
        String(data.chart.datasets[0].data[i]),
        String(data.chart.datasets[1].data[i]),
        String(data.chart.datasets[0].data[i] + data.chart.datasets[1].data[i])
      ])
    ];
  },

  collections: (data) =>
    data?.rawData
      ? [
          ['Collection', 'Count'],
          ...data.rawData.map((item: any) => [
            item.collection,
            String(item.count),
          ]),
        ]
      : [],
  
  journals: (data) => data ? [
    ['Amount', 'Agreement', 'Agreement Link', 'Journal name', 'Journal Link', 'Imprint', 'Payment option', 'Publishing model'],
    ...data.map((item: any) => [
      String(item.count),
      item.agreement_name || item.agreement,
      item.agreement_id ? `${window.location.origin}/agreements/${item.agreement_id}` : '',
      item.name,
      item.url || '',
      item.imprint,
      item.payment,
      item.publishing_model
    ])
  ] : [],
  
  widgetOrigins: (data) => {
    const showAccount = Boolean(data?.showAccount);
    return [
      [...(showAccount ? ['Account'] : []), 'Host', 'Page', 'Count'],
      ...(data?.rows || []).map((item: any) => [
        ...(showAccount ? [item.account || ''] : []),
        item.host,
        item.path,
        String(item.count),
      ]),
    ];
  },

  default: (data) => data?.rawData ? [
    ['Search Term', 'Count'],
    ...data.rawData.map((item: any) => [item.term, String(item.count)])
  ] : []
};

// Generate CSV data for export
export const generateCSVData = (tabKey: string, data: any, t: (key: string) => string) => {
  const generator = CSV_GENERATORS[tabKey] || CSV_GENERATORS.default;
  return generator(data);
};